<template>
  <vs-row vs-type="flex" vs-align="center" vs-justify="flex-start">
    <feather-icon :icon="icon" svgClasses="h-5 w-5" />
    <span class="ml-3">{{title}}</span>
  </vs-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
  },
}
</script>
